import { render, staticRenderFns } from "./Kelengkapan.vue?vue&type=template&id=d1867f74&"
import script from "./Kelengkapan.vue?vue&type=script&lang=js&"
export * from "./Kelengkapan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports